
//STRINGS FOR REDEEM PAGES
const REDEEMPAGE_STRINGS  = {
    KEY_AMOUNT_STRING :'Amount',
    KEY_CANCEL_REDEEM :'Cancel Withdraw',
    KEY_CUSTOMERCARE_INFO1 : 'For any help ,drop an email to',
    KEY_CUSTOMERCARE_EMAIL: 'a23support@hdworks.in ',
    KEY_CUSTOMERCARE_CALL:'or call',
    KEY_CUSTOMERCARE_PHONE : '1800-258-1234?',
    KEY_CUSTOMERCARE_CHRAGES : ' (call charges apply)',
    KEY_REQUEST : 'Request',
    KEY_PENDING : 'Pending',
    KEY_HISTORY : 'History',
    KEY_ADD_BANK: 'Add Bank',
    KEY_REDEEM_REQEST : 'Withdraw Request',
    KEY_KYC : 'KYC',
    KEY_SPINNER_VALUE1:'ALL',
    KEY_SPINNER_VALUE2:'Successfull',
    KEY_SPINNER_VALUE3:'Pending',
    KEY_SPINNER_VALUE4:'Rejected',
    KEY_SPINNER_VALUE5:'Cancelled',
    KEY_REDEEM_BALANCE:'Withdrawble Balance :',
    KEY_ENTER_REDEEM_AMOUNT:'Enter Withdraw Amount :',
    KEY_ENTER_ACCOUNT_NAME:'Account Name',
    KEY_BTN_APPLY:'Apply',
    KEY_FOR_ANY_QURIES:'For any help ,drop an email to ',
    KEY_REDEEM_INFO_MAIL:'a23support@hdworks.in',
    KEY_OR_CALL:'or call',
    KEY_REDEEM_INFO_MOBILE:'1800-258-1234',
    KEY_CALL_CHARGES:'(call charges apply)',
    KEY_PLACE_REDEEM_TV:'Request Withdraw',
    KEY_REDEEM_HISTORY_TV:'Withdraw History',
    KEY_INPUT_HINT_TV:'Enter Amount',
    KEY_REDEEM_OPTIONS_TV:'Withdraw Options',
    KEY_ADD_TV:'Add',
    //adding dependency with server
    KEY_APPROVED_TV:'approved',
    KEY_EMPTY_TV:'empty',
    KEY_DELETE_TV:'delete',
    KEY_WALLET_TV:'wallet',
    KEY_ACTIVE_TAB_REDEEM_TV:'withdraw',
    KEY_WITHDRAW_OPTION_SELECT_ERROR_TV:'Please select a option to withdraw',
    KEY_ACTIVE_TAB_REDEEM_HISTORY_TV:"redeemhistory",
    KEY_PROCESSING_TV:"processing",
    KEY_BANKACCOUNT_VERIFICATION_HEADER_TV:'Bank Account Verification',
    KEY_BANKACCOUNT_VERIFICATION_msg_TV:'We are facing issues verifying your Bank Account. Please check again in sometime or wait for further communication from A23.',
    KEY_BANK_ADDED_MSG_TV:'Your bank account has been added successfully',
    KEY_BANK_TIMER_MSG_TV:'timerend',
    KEY_BANK_ADD_ERROR_MSG_TV:'You can add another bank account only after the previous one has been added successfully',
    KEY_BANK_PROCESS_KYC_MSG_TV:'You can add a new bank account only after your KYC is verified',
    KEY_UPI_PROCESS_KYC_MSG_TV:'You can add a new UPI id only after your KYC is verified',
    KEY_MOBILE_UNDEFINED_MSG_TV:'Please verify your mobile number from My Account page.',
    KEY_REDEEM_AMOUNT_EMPTY_MSG_TV:'Enter a valid Withdraw Amount',
    KEY_KYC_VERIFY_ERROR_TV:'Please verify your KYC to place a Redeem.',
    KEY_REDEEMABLE_BALANCE_ERROR_TV:'You don\'t have sufficient withdrawable balance.',
    KEY_BALANCE_LIMIT_ERROR_TV:'Please enter amount less than or equal to withdrawable balance',
    KEY_ADDCASH_ERROR_MSG_TV:'You need to add cash once before placing a withdraw request.',
    KEY_ACELEVEL_ERROR_MSG_TV_1:'You can only place a withdraw of upto',
    KEY_ACELEVEL_ERROR_MSG_TV_2:'per request.',
    KEY_REDEEM_MINIMUM_AMOUNT_ERROR_TV:'Please enter an amount greater than the minimum withdraw amount.',
    KEY_REDEEMABLE_BALANCE_ALERT_MSG_TV:'Please enter an amount upto your withdrawable balance.',
    KEY_REDEEM_ONLY_TV_1:'You can place maximum',
    KEY_REDEEM_ONLY_TV_2:'redeems per day.',
    KEY_BANK_PENDING_VERIFICATION:'Pending Verification',
    KEY_REDEEM_MOBILE_VERIFY_TEXT:'Please verify your mobile number in My Account to add a wallet.',
    KEY_REDEEM_MOBILE_VERIFY_BTN_TEXT:'Go to My Account',
    KEY_REDEEM_DECIMAL_MSG_ERROR:'Please enter a valid rounded-off amount. Decimals and other special characters are not allowed.',
    KEY_BANKNAME_NOT_AVAILABLE_TV:'Not Available',
    KEY_UPI_ADD_ERROR_MSG_TV:'You can add another UPI only after the previous one has been added successfully',
    KEY_BANKACCOUNT_PROCESSING_MSG_TV:'We are processing your request for bank account verification. Please check again in sometime or wait for further communication from A23 in case of any delay.' //PL-9974
} 

//Strings for walletinfo
const WALLETPAGE_STRINGS = {
    KEY_WALLET_HEADING_TV:'My Wallet',
    KEY_TOTAL_BALANCE_TV:'Total Balance',
    KEY_ADDCASH_TV:'Add Cash',
    KEY_REDEEMABLE_BALANCE_TV:'Withdrawable Balance',
    KEY_REDEEM_TV:'Redeem',
    KEY_LOCKED_BONUS_TV:'Locked Bonus',
    KEY_ACEPOINTS_TV:'AcePoints',
    KEY_TRANSACTION_SUMMARY_TV:'Transaction Summary',
    KEY_APP_VERSION_TV:'App Version',
    KEY_REDEEMABLE_BALANCE_TOOLTIP_TV:'Withdrawable balance is the balance that you are entitled to withdraw, it is calculated based on your activity (win/losses) on various game tables.',
    KEY_REDEEMABLE_BALANCE_CLICK_HERE_TV:'Click here',
    KEY_REDEEMABLE_BALANCE_TOOLTIP_MORE_INFO_TV:'For more information',
    KEY_LOCKED_BONUS_TOOLTIP_TV:'Bonus will be added to your wallet balance as per bonus release ratio of the respective bonus code and your Ace Level. Bonus will expire as per the respective bonus code\'s T&C\'s.',
    KEY_LOCKED_BONUS_TOOLTIP_MORE_TV:'to know more',
    KEY_ACEPOINTS_TOOLTIP_TV:'Acepoints are reward points offered for your engagement at various games on A23. You earn 1 acepoint everytime you play with Rs.100 on our real money games. Reward points accrued overtime unlocks higher ace levels.',
    //PL-5949
    KEY_LOYALITY_PROGRAM:'Loyalty Program',
    //PL-5949
    //PKS
    KEY_POKER_REDEEMABLE_BALANCE:'Withdrawable Poker Balance',
    KEY_POKER_BALANCE:'Poker Wallet',
    KEY_PK_A23_BALANCE:'A23 Wallet',
    //Poker
    KEY_PK_EDITTEXT_PLACEHOLDER_TEXT:"Enter amount to transfer to poker balance",
    KEY_PK_MINIMUM_AMOUNT_ERROR_TV:'The max amount you can transfer is ',
    KEY_PK_DECIMAL_MSG_ERROR:'Please enter a valid rounded-off amount. Decimals and other special characters are not allowed.',
    KEY_PK_AMOUNT_EMPTY_MSG_TV:'Please enter a valid amount',
    KEY_PK_AMOUNT_AMOUNT_TRANSFER_NOTE_TV:'Amount will be deducted from A23 Balance',
    KEY_PK_AMOUNT_TRANFER_BTN_TEXT:'Transfer to Poker Balance',
    KEY_PK_TOTAL_INFO_MSG:'Total of Deposits, Winnings Balance, & Bonuses',
    KEY_PK_REDEEMABLE_BALANCE_INFO:'Total amount you are entitled to Withdraw. It includes Winnings & Wagered Bonuses',
    KEY_PK_A23_TOTAL_INFO:'Total of Deposits, Winnings Balance, & Bonuses. You can transfer entire amount to Poker wallet for playing cash games & tournaments',
    KEY_PK_A23_REDEEMABLE_INFO:'Total amount you are entitled to redeem, which includes Winnings & Wagered Bonus.',
    KEY_PK_A23_LOCKEDBONUS_INFO:'You can unlock this bonus as per the bonus release ratio. Once unlocked, this expirable bonus will reflect under A23 Withdrawable Balance.',
    KEY_PK_A23_ACEPOINTS_INFO:'Loyalty Points are offered based on your wagering. You can withdraw Ace points from the My Wallet/Withdraw Page in Hamburger Menu.',
    KEY_PK_A23_TS_INFO:'All transactions related to other A23 Games',
    KEY_PK_TDS_INFO:'',
    KEY_PK_TO_A23_TRANSFER_BTN_TEXT:'Transfer to A23 Balance',
    KEY_PK_A23_TRANSFER_MSG:'Complete poker balance gets transferred',
    KEY_PK_A23_TS_TEXT:"A23 Transaction Summary",
    KEY_PK_INSUFFICIENTBALANCE_ADDCASH:"Insuffient balance , Please Add Cash to Continue.",
    KEY_PK_TRANSFER_REQUEST_PENDING:"Your transfer request is in progress.",
    KEY_PK_TRANSFER_ZERO_VALIDATION:"Please don\'t enter \"0\" as first digit",
    KEY_PK_BONUS_CASH:"Bonus Cash",
    // KEY_PK_BONUS_CASH_TOOLTIP_INFO:"Bonus will be added to your wallet balance as per respective bonus code or bonus release ratio"
    KEY_PK_BONUS_CASH_TOOLTIP_INFO:"Instant Cash+Unlocked Bonus"
   
}


//LINK WALLET STRINGS
const LINKWALLET_STRINGS={
    KEY_ENTER_OTP_TV:'Enter OTP',
    KEY_OTP_SEND_TV:'OTP has been sent to',
    KEY_RESEND_OTP_TV:'Resend OTP',
    KEY_CONFIRM_BTN_TV:'Confirm',
    KEY_OTP_EMPTY_TV:'OTP cannot be blank',
    KEY_OTP_LENGTH_ERROR_TV:'OTP must be of 6 digits',
    KEY_BANKACCOUNT_TV:'bankAccount',
    KEY_UPI_TV:'upi',
    KEY_PAYTMWALLET_TV:'paytmWallet',
    KEY_PAYTM_TV:'paytm',
    KEY_AMAZONPAY_TV:'amazonPay'
  }
  
  

//VERIFY UPI STRINGS
const VERIFYUPI_STRINGS={
    KEY_UPI_HEADER_TV:'UPI ID/VPA',
    KEY_ENTER_UPI_HINT_TV:'Enter UPI/VPA',
    KEY_RE_ENTER_UPI_HINT_TV:'Re-enter UPI/VPA',
    KEY_CONFIRM_ACCOUNT_NAME_TV:'Please confirm Account Name',
    // PL-4991 Issue Fix
    KEY_VERIFY_UPI_NOTE_TV:'Note: Name in your UPI/VPA linked bank account must match with the name in PAN submitted to A23',
     // PL-4991 Issue Fix
    KEY_VERIFY_BTN_TV:'Verify',
    KEY_OKAY_BTN_TV:'Okay',
    KEY_REJECTED_TV:'reject',
    KEY_VERIFY_UPI_SUCCESS_HEADER_TV:'Thanks for submitting your UPI id.',
    KEY_VERIFY_UPI_SUCCESS_MSG_TV:'We are verifying it and will update you once done.',
    KEY_UPI_EMPTY_MSG_TV:'Enter Valid UPI id.',
    KEY_REENTER_UPI_EMPTY_MSG_TV:'Enter Valid UPI id,',
    KEY_UPI_MISMATCH_TV:'Entered UPI/VPA id doesn\'t match',
    KEY_VERIFYING_BTN_TV:'Verifying',
    //For GFPS Changes
    KEY_VERIFY_UPI_NOTE_TV_PLAYSTORE:'Note: Name in your UPI/VPA linked bank account must match with the name in KYC doc submitted to A23'    
}


//Bonus Summary related Strings
const BONUSSUMMERY_STRINGS  = {
    KEY_BONUS_SUMMARY :'Bonus Summary',
    KEY_BONUS_SUMMARY_TEXT1 :'Want to unlock more?',
    KEY_BONUS_SUMMARY_TEXT2 : 'Bonus is added to cash balance.',
    KEY_BONUS_SUMMARY_TEXT3: 'Bonus is based on the cash used for playing.',
    KEY_BONUS_SUMMARY_TEXT4:'Bonus is available for playing cash games and tourneys. ',
    KEY_BONUS_SUMMARY_TEXT5 : 'No Pending bonus to be released',
    KEY_BONUS_SUMMARY_EXPIRY_DATE : ' Expiry Date :',
    KEY_BONUS_SUMMARY_WAGER_RATIO : 'Wagering Ratio:',
    KEY_BONUS_SUMMARY_ISSUE_DATE : 'Issued Date :',
    KEY_BONUS_SUMMARY_ISSUE_AMOUNT : 'Issued Amount:',
    KEY_BONUS_SUMMARY_INSTANT_ISSUE_AMOUNT: 'Instant Issued Amount:',
    KEY_BONUS_SUMMERY_CREDITED_AMOUNT : 'Credited Amount:',
    KEY_BONUS_SUMMERY_PENDING_AMOUNT:'Pending Amount:',
    KEY_BONUS_SUMMARY_GAME_WISE : 'Game-wise',
    KEY_BONUS_SUMMARY_TEXT6:'Bonus will be added to cash balance based  upon real money games played.',
    KEY_BONUS_SUMMARY_MORE_INFORMATION:'More Information',
    KEY_BONUS_SUMMARY_TEXT7:'Mobile number must be verified for unlocking bonus.',
    KEY_BONUS_SUMMARY_TEXT8:'Pending bonus will be released and credited to cash balance in fixed chunks varying by Ace level.',
    KEY_BONUS_SUMMARY_LEVEL:'Level',
    KEY_BONUS_SUMMARY_CREDIT:'Credit',
    KEY_BONUS_SUMMARY_TEXT8:'If bonus has been released but not credited, it will be auto credited after expiry date.',
    KEY_BONUS_SUMMARY_TEXT9:'Bonus Release criteria will vary as per respective bonus code\'s T&C\'s',
    KEY_BONUS_SUMMARY_TEXT10:'Bonus with earlier expiry date will be released first.',
    KEY_BONUS_SUMMARY_WAGERING_TV:'Wagering ratios vary game wise'
 
} 

//Transaction Summery Realted Strings
const TS_STRINGS  = {
    KEY_TS:'Transaction Summary',
    KEY_TS_PENDING_TRANSACTIONS:'Pending/Failed transactions',
    KEY_TS_CHECK_STATUS:'Check Status',
    KEY_TS_DATE_RANGE:'Date Range',
    KEY_TS_TYPE:'Transaction Type',
    KEY_TS_TODAY:'Today',
    KEY_TS_SEVEN_DAYS:'7 days',
    KEY_TS_FIFTEEN_DAYS:'15 days',
    KEY_TS_THIRTY_DAYS:'30 days',
    KEY_TS_ALL:'All',
    KEY_TS_ADDCASH:'Add Cash',
    KEY_TS_REDEEM:'Withdraw',
    KEY_TS_RUMMY:'Rummy- Tourney/Game',
    KEY_TS_FANTACY:'Fantasy- Contest',
    KEY_TS_POKER:'Poker- Tourney/Game',
    KEY_TS_CARROM:'Carrom- Game',
    KEY_TS_POOL:'Pool- Game',
    KEY_TS_REDEEM_CANCEL:'Withdrawal Cancellation',
    KEY_TS_REFUND:'Refund',
    KEY_TS_BONUS:'Bonus Claimed',
    KEY_TS_DAYS:'days',
    KEY_TS_PAYMENT_MODE:'Payment Mode:',
    KEY_TS_TRANSCATION_ID:'Transaction ID: ',
    KEY_TS_TIME:'Time: ',
    KEY_TS_VOUCHER_CODE:'Voucher Code:',
    KEY_TS_DESCRIPTION:'Description:',
    KEY_TS_GAMEID:'Game ID:',
    KEY_TS_TOURNE_ID:'Tourney ID:',
    KEY_TS_CONTEST_ID:'Contest ID: ',
    //For Failed Transactions
    KEY_TS_FAILED_TRANSCATIONS:'Pending/Failed Transactions',
    KEY_TS_RECHECK:'Re-Check',
    KEY_TS_VERIFY:'Verify KYC',
    KEY_TS_NO_DATA:'No transaction found to display',
    KEY_TS_LEADERBOARD_ID:'Leaderboard ID:',
    KEY_TS_CALLBREAK:'Call Break - Tourney/Game'
} 

  
//Transaction Summery Realted Strings
const REDEEM_HISTORY  = {
    REDEEM_HISTORY_CANCEL:'Cancel Withdraw',
    REDEEM_STATUS_CODE_1205:'Withdraw processed should reflect in your bank account/wallet in 2-3 working days.',
    REDEEM_STATUS_CODE_1206:'This withdraw is already cancelled.',
    REDEEM_STATUS_CODE_1207:'Withdrawal cancelled.',
    REDEEM_HISTORY_CANCEL_REDEEM:'Cancel Withdraw Request',
    REDEEM_HISTORY_TEXT:'Are you sure you want to cancel this withdraw request?',
    REDEEM_HISTORY_YES_BUTTON:'Yes',
    REDEEM_HISTORY_NO_BUTTON:'No',
    REDEEM_HISTORY_STATUS:'Status',
    REDEEM_HISTORY_PAYMENT_MODE:'Via:',
    REDEEM_HISTORY_ID:'Withdraw ID:',
    REDEEM_HISTORY_NO_STATUS:'You can access Withdraw history and status from this page.',
    REDEEM_STATUS_CODE_777:'Withdrawal cancellation is disabled by responsible gaming team @ A23.',
    REDEEM_HISTORY_RG_ALERT:'Alert',
    REDEEM_HISTORY_RG_ALERT_TEXT:'As per our responsible gaming policy, this action is restricted for you.',
    REDEEM_HISTORY_RG_ALERT_BTN:'Ok',
       
} 


//REDEEM INFO
const REDEEM_INFO = {
    REDEEM_INFO_TEXT1 :'What is withdrawble balance?',
    REDEEM_INFO_TEXT2 :'Withdrawble balance is the maximum cash balance that you are entitled to withdraw from your account at any point of time. It is calculated based on your wins/losses on various game tables. Cash added by a player can solely be used to play cash tables and tournaments. To know more please read our',
    REDEEM_INFO_TEXT3 :'Standard Withdraw Limits by Ace Level',
    REDEEM_INFO_ACE_LEVEL:'Ace Level',
    REDEEM_INFO_REQUESTS :'No of requests/',
    REDEEM_INFO_DAY:'day',
    REDEEM_INFO_AMOUNT :'Max Amount per',
    REDEEM_INFO_REQUEST:'Request',
    //PL-5167 Issue Fix Start
    REDEEM_INFO_TEXT4 :'Limits are subject to change based on our withdraw policies.',
    //PL-5167 Issue Fix End
    REDEEM_INFO_TEXT5 : 'To withdraw your total balance, please contact our customer support team at ',
    REDEEM_TERMS_AND_CONDITIONS_TEXT:'T&C',
    REDEEM_INFO_A23_LINK:'info@a23.com.',
    REDEEM_INFO_LINK_TEXT:'T&C apply.',
    REDEEM_INFO_TERMS_AND_CONDITIONS:'Terms & Conditions'
}

//REDEEM FEATURE DISABLE ALERT
const REDEEM_DISABLE_ALERT = {
    REDEEM_DISABLE_ALERT_TEXT :'Access Restricted',
    REDEEM_DISABLE_ALERT_TEXT1 :'This feature is not available in this app. Please visit website a23.com for more details. ',
    REDEEM_DISABLE_ALERT_TEXT2 :'This feature is not available from the location you are currently accessing A23 Games.',
    REDEEM_DISABLE_ALERT_OK_BTN:'Ok',
}

//REMOVE WALLET
const REMOVE_WALLET_ALERT = {
    REMOVE_WALLET_DELETE :'Delete',
    REMOVE_WALLET_BANK_TEXT :'Are you sure you want to delete this  bank account ?',
    REMOVE_WALLET_BTN_DELETE :'Delete',
    REMOVE_WALLET_BTN_CANCLE:'Cancel',
    REMOVE_WALLET_REDEEM :'Withdraw Option',
    REMOVE_WALLET_TEXT :'Do you wish to delete the withdraw option ',
    REMOVE_WALLET_YES_BTN :'Yes',
    REMOVE_WALLET_NO_BTN :'No',
}

//VERIFY KYC
const VERIFY_KYC_ALERT = {
    VERIFY_KYC_REDEEM :'Withdraw',
    VERIFY_KYC_ALERT_TEXT :'Please verify your KYC to continue.',
    VERIFY_PAN_ALERT_TEXT: 'Please verify your PAN to continue.',
    VERIFY_KYC_ALERT_BTN_VERIFY :'Verify Now',
}

//UPI ALERT
const UPI_ALERT = {
    UPI_ALERT_TEXT :' Note: Name in your UPI/VPA linked bank account must match with the name in PAN submitted to A23.'
}

//add bank account related strings
const ADD_BANK_PAGE_STRINGS  ={
    KEY_ADD_BANK_VERIFICATION_TITLE:'Account addition Failed',
    KEY_ADD_BANK_VERIFICATION_BODY:'You cannot add this bank account as the name linked to this account is different to that on the PAN you have submitted. Please submit a account which belongs to you.',
    KEY_ADD_BANK_VERIFICATION_OKAY:'Ok',
    KEY_ADD_BANK_11_DIGITS_IFSC:'Please enter 11 Digits IFSC Code',
    KEY_ADD_BANK_SUCCESS_MSG:'IFSC validation successful. Please proceed.',
    KEY_ADD_BANK_ENTER_ACC_NUMBER:'Enter valid account number',
    KEY_ADD_BANK_ENTER_RE_ACC_NUMBER:'Re-enter valid account number',
    //PL-6923 Change
    //KEY_ADD_BANK_PLEASE_VERIFY_IFSC:'Please verify IFSC code',
    KEY_ADD_BANK_PLEASE_VERIFY_IFSC:'Please re-enter the IFSC code to proceed',
    //PL_6923 Change End
    KEY_ADD_BANK_ACC_NUMBER_NOT_MATCH_RE_ENTER:"Entered account numbers don't match, please re-enter",
    KEY_ADD_BANK_VERIFY_BUTTON_TEXT:"Verify",
    KEY_ADD_BANK_VERIFY_ACC_TEXT:"Verify bank account details",
    // For PL1.4 UI/UX Changes text has been changed
    KEY_ADD_BANK_NOTE: "Note:",
    KEY_ADD_BANK_ONLY_ACCEPT_SAME_PAN_NAME_NOTE: "1. We only accept bank accounts with account name similar to name on PAN submitted to A23.",
    KEY_ADD_BANK_WILL_SEND_ONE_RUPEE_TO_ACC:'2. For the verification we will send ₹1 to your bank account.',
    //For PL1.4 UI/UX Changes text has been changes
    KEY_ADD_BANK_ONCE_VERIFY_WILL_ADD_IT_TO_A23:'Once your bank account is verified we will add it to your A23 Account.', 
    //Panmissmatched Test POPUP TESt
    KEY_PAN_MISMATCH_TITLE:'Account not added',
    KEY_PAN_MISMATCH_CONTENT:'The name in the bank account differs from the name in the PAN card submitted by you. Please provide bank account that matches your PAN.',
    KEY_PAN_MISMATCH_BTN_TEXT:'Ok',

     //For GAPS and GFPS Changes start

     KEY_ADD_BANK_ONLY_ACCEPT_SAME_PAN_NAME_NOTE_GAPS: "1.  We only accept bank accounts with account name similar to name on KYC doc submitted to A23.",
     //For GAPS and GFPS Changes end
   
   
}
//Static Web URL'
const STATIC_WEB_PAGES ={
    KEY_IFSC_CODE_URL:'https://www.bankbazaar.com/ifsc-code.html',
    KEY_BONUS_SUMMERY_URL:'https://qaweb.qapfgames.com/rummybonus.html?src=mapp&platformapp=Y&header=N',
    KEY_TERMS_AND_CONDITIONS:'https://qaweb.qapfgames.com/termsandconditions.html?src=mapp&&platformapp=Y&header=N'
}

//KYC Documents Submitted
export const KYC_DOCUMENTS ={
    KEY_KYC_DOCUMENTS_SUBMIITTED_HEADER:'KYC Documents \n Submitted',
    KEY_KYC_SUBMITTED_BODY:'Your KYC is submitted and is pending approval.Once verified you will be able to withdraw your winnings.',
    KEY_KYC_SUBMITTED_BTN_TEXT:'Ok',
    KEY_KYC_VIEW_DETAILS:'Your winnings are on hold until you verify KYC.'
}

//Poker TDS Info
//REDEEM INFO
const POKER_TDS_INFO = {
    POKER_TDS_INFO_HEADER :'Cash Transfer',
    POKER_TDS_ONTRANSFER :'On transfer',
    POKER_CREDITED_TO_A23_BALANCE :'Credit to A23 Balance',
    POKER_TDS_DEDUCTION:'TDS deduction',
    POKER_TDS_TRANSFER :'Transfer',
    POKER_CASH_TRANSFER_TEXT:"No TDS is applicable on your transfer of amount from Poker balance to A23 balance.",
    POKER_CASH_TRANSFER_CONFIRMATION_TEXT:"Are you sure you want to transfer your entire balance to A23 Wallet?", //new change during TDS @yashwanth
    POKER_CASH_TRANSFER_NOTE_TEXT:"Note: Any TDS applicable will be deducted during withdrawals", //new change during TDS @yashwanth
    PK_KYC_APPROVED:'approved',
    PK_KYC_REJECTED:'rejected',
    PK_KYC_BLOCKED:'blocked',
    PK_KYC_PROCESSING:'processing',
    PK_KYC_UNVERIFIED:'unverified',
    PK_KYC_NOT_SUBMITTED:'not submitted',
    PK_KYC_PROCESSING_TEXT_MSG:'Your KYC verification is under process,transfer cannot be placed.',
    PK_KYC_BLOCKED_TEXT_MSG:'Your KYC is suspended due to legal compliance ,contact A23.',
    PK_KYC_REJECTED_TEXT_MSG:'Your KYC was rejected , transfer cananot be placed.',
    PK_KYC_NOT_SUBMITTED_TEXT_MSG:'TDS is applicable on this transfer and requires PAN verificcation.',
    PK_KYC_UNVERIFIED_TEXT_MSG:'Your KYC has been unverified,transfer cannot be placed.',
    PK_KYC_VERIFY_PAN:"Verify PAN",
    PK_KYC_OKAY:"Okay",
    PK_KYC_REVERIFY:"Reverify PAN",
    POKER_TDS_PAN_VERIFICATION_HEADER :'PAN Verification',
    POKER_TDS_INFO_TOOLTIP_MESSAGE1:'31.2% TDS will be deducted on Net Winnings of Rs.10,000 & above at the time of Poker balance to A23 balance Transfer. ',
    POKER_TDS_INFO_TOOLTIP_MESSAGE2:'Net Winnings will be calculated every time a user transfers Poker balance to A23 balance.',
    POKER_INSUFFICIENT_BALANCE:'You have insufficient balance',
    POKER_COMMONALERT_CLOSE:'Close',
    POKER_BALANCE_A23_TEXT_MSG1:'Would you like to transfer ',
    POKER_BALANCE_A23_TEXT_MSG2:'amount from A23 balance to Poker balance',
    
}

const RUPEE_SYMBOL = "\u20B9";


export {RUPEE_SYMBOL,ADD_BANK_PAGE_STRINGS,UPI_ALERT,REMOVE_WALLET_ALERT,VERIFY_KYC_ALERT,REDEEM_DISABLE_ALERT,REDEEM_INFO,REDEEM_HISTORY,TS_STRINGS,BONUSSUMMERY_STRINGS,REDEEMPAGE_STRINGS,WALLETPAGE_STRINGS,LINKWALLET_STRINGS,VERIFYUPI_STRINGS,POKER_TDS_INFO};